module.exports = __webpack_public_path__ + "img/questionnaire.73e05755.png";